import React, { useEffect, useState } from 'react'
import apiCall from '../helper/apiCall';
import { toast } from 'react-toastify';
import CouponForm from '../components/CouponForm';
import Modal from '../components/Modal';
const Coupon = () => {
const [coupons, setCoupons] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState('add');
    const [couponToEdit, setCouponToEdit] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetchCoupons = async () => {
        setIsLoading(true);
        try {
            const result = await apiCall('getCoupons');
            if (result.success && result.data) {
                setCoupons(result.data);
            } else {
                setCoupons([]);
                toast.error("Failed to fetch coupons.");
            }
        } catch (error) {
            console.error("Failed to fetch coupons:", error);
            toast.error("Error fetching coupons.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCoupons();
    }, []);

    const handleAddCoupon = () => {
        setModalType('add');
        setIsModalOpen(true);
        setCouponToEdit(null);
    };

    const handleEditCoupon = (coupon) => {
        setModalType('edit');
        setIsModalOpen(true);
        setCouponToEdit(coupon);
    };

    const handleSaveCoupon = async (newCoupon) => {
        let result;
        if (modalType === 'add') {
            result = await apiCall('createCoupon', newCoupon);
        } else {
            result = await apiCall('updateCoupon', newCoupon);
        }
        
        if (result.success) {
            // Re-fetch the data to ensure the UI is in sync with the backend
            fetchCoupons(); 
            toast.success(`Coupon ${modalType === 'add' ? 'created' : 'updated'} successfully!`);
        } else {
            toast.error(`Failed to ${modalType === 'add' ? 'create' : 'update'} coupon.`);
        }
        setIsModalOpen(false);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setCouponToEdit(null);
    };
    
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US');
    };

    return (
        <div className="p-8 font-sans bg-gray-100 min-h-screen">
            <h1 className="text-3xl font-extrabold text-gray-900 mb-6">Coupon Management</h1>
            <div className="flex justify-between items-center mb-6">
                <span className="text-lg font-semibold text-gray-700">All Coupons</span>
                <button
                    onClick={handleAddCoupon}
                    className="bg-indigo-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-indigo-700 transition-colors"
                >
                    Add Coupon
                </button>
            </div>
            {isLoading ? (
                <div className="text-center py-8 text-gray-500">Loading coupons...</div>
            ) : (
                <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Coupon Code
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Discount
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Min Order Value
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Usage Limit
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Expiry
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Status
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {coupons.length > 0 ? (
                                    coupons.map(coupon => (
                                        <tr key={coupon.coupon_code} className="hover:bg-gray-50 transition-colors duration-150">
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{coupon.coupon_code}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {coupon.channel === 'Retail' ? (
                                                '0'
                                            ) : (
                                                coupon.discount_type === 'FIXED' ? `₹${coupon.discount_value}` : `${coupon.discount_value}%`
                                            )}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">₹{coupon.min_order_value}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{coupon.usage_limit}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(coupon.expiration_date)}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${coupon.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                                    {coupon.is_active ? 'Active' : 'Inactive'}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <button
                                                    onClick={() => handleEditCoupon(coupon)}
                                                    className="text-indigo-600 hover:text-indigo-900 transition-colors"
                                                >
                                                    Edit
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="px-6 py-4 text-center text-gray-500">No coupons found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            
            <Modal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                title={modalType === 'add' ? 'Add New Coupon' : 'Edit Coupon'}
            >
                <CouponForm
                    initialData={couponToEdit}
                    onSave={handleSaveCoupon}
                    onClose={handleCloseModal}
                />
            </Modal>
        </div>
  )
}

export default Coupon